import React, { useState, useEffect } from 'react';
import "../Website.css";
import OverlapSection from './OverlapSection';
import CtaSection from './CtaSection';
import Header from '../components/common/Header-w';
import CareerFooter from './AboutUs/CareerFooter';


function LandingPageTwo() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        if (isMobileMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMobileMenuOpen]);

    return (
        <div
            className="text-white font-inter min-h-screen w-full relative overflow-hidden"
        >
            {/* <Header isLandingPageTwo={true} onMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} /> */}

            {/* Dot background as independent layer */}
            <div
                style={{
                    position: 'absolute',
                    top: 80,
                    left: '70px',
                    right: '70px',
                    bottom: 0,
                    backgroundImage: 'radial-gradient(circle at 1px 1px, #80808029 1px, transparent 2px)',
                    backgroundSize: '30px 30px',
                    backgroundRepeat: 'repeat',
                    backgroundPosition: '0 0',
                    zIndex: 0, // Behind the main content
                }}
            />

            {/* Main Content */}
            <main className="tw-relative tw-z-10">
                <Header />
                <OverlapSection />
                <CtaSection />
                <CareerFooter theme="light" />
            </main>
        </div>
    );
}

export default LandingPageTwo;
